import { Controller } from "@hotwired/stimulus"

// Inline note editor for a POS check line.
//   - toggle(): reveals the editor + autofocuses the input so the tablet
//     keyboard pops up immediately.
//   - cancel(): hides the editor and restores the prior value; called from
//     the explicit Cancel button and from Escape.
export default class extends Controller {
  static targets = ["editor", "input"]

  connect() {
    this.boundKey = this.#handleKey.bind(this)
  }

  disconnect() {
    window.removeEventListener("keydown", this.boundKey)
  }

  toggle(event) {
    event?.preventDefault()
    this.editorTarget.classList.toggle("hidden")
    if (!this.editorTarget.classList.contains("hidden")) {
      this.initialValue = this.inputTarget.value
      this.inputTarget.focus()
      this.inputTarget.select()
      window.addEventListener("keydown", this.boundKey)
    } else {
      window.removeEventListener("keydown", this.boundKey)
    }
  }

  cancel(event) {
    event?.preventDefault()
    this.inputTarget.value = this.initialValue ?? ""
    this.editorTarget.classList.add("hidden")
    window.removeEventListener("keydown", this.boundKey)
  }

  #handleKey(e) {
    if (e.key === "Escape") this.cancel(e)
  }
}
